import { DETAIL_APPOINTMENT } from "./appointment-detail.query";
import { IAppointmentItemResponse } from "../appointment-list/appointment-list.interface";
import { useLazyQuery } from "@apollo/client";

export const useApppointmentDetail = () => {
  const [
    appointmentDetail, { data, loading },
  ] = useLazyQuery<{ appointmentDetail: IAppointmentItemResponse }>(DETAIL_APPOINTMENT);

  const getAppointment = (id: string) => {
    appointmentDetail({
      variables: {
        id,
      },
      fetchPolicy: "cache-and-network",
    });
  };

  return {
    getAppointment,
    appointment: data?.appointmentDetail,
    loading,
  };
};
